<template>
  <el-dialog
    v-loading="loading"
    class="zoom-modal"
    width="90%"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <div v-if="type===1" class="chart-wraper">
      <div class="header">
        <div>配件销售<el-button size="mini" type="text" style="margin-left: 8px;" v-uac="'home.partOrderExp'" @click="doExp">导出</el-button></div>
        <div>
          <time-span v-model="orderLineSpan" />
        </div>
      </div>
      <div class="inner">
        <order-line-chart ref="orderLineChart" id="zoom-line" :time-span="orderLineSpan" height="540px" />
      </div>
    </div>
    <div v-else class="chart-wraper">
      <div class="header">
        <div>
          各地区品牌销售
          <el-button size="mini" type="text" style="margin-left: 8px;" v-uac="'home.partOrderExp'" @click="doExpByArea">导出</el-button>
        </div>
        <div>
          <time-span-selector v-model="orderDiscountSpan" />
        </div>
      </div>
      <div class="inner">
        <OrderStatisticByMap ref="orderLineChartByArea" id="zoom-map" :time-span="orderDiscountSpan" />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import OrderLineChart from './OrderLineChart.vue'
import OrderStatisticByMap from './OrderStatisticByMap.vue'
import TimeSpanSelector from '@/components/TimeSpanSelector.vue'
import TimeSpan from '@/components/TimeSpan.vue'
export default {
  name: 'ZoomModal',
  mixins: [ModalMixin],
  components: { OrderStatisticByMap, OrderLineChart, TimeSpanSelector, TimeSpan },
  data () {
    const now = new Date()
    const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
    const startTime = new Date(now.getFullYear(), now.getMonth(), 1)
    return {
      loading: false,
      type: 1,
      orderLineSpan: {
        range: [startTime, endTime],
        rangeType: 'daterange',
        isOrder: true,
        partType: undefined
      },
      orderDiscountSpan: [startTime, endTime]
    }
  },
  methods: {
    init (type) {
      this.type = type
      return this.open()
    },
    doExp () {
      if (this.$refs.orderLineChart) {
        this.$refs.orderLineChart.$emit('exportExcel')
      }
    },
    doExpByArea () {
      if (this.$refs.orderLineChartByArea) {
        this.$refs.orderLineChartByArea.$emit('exportExcel')
      }
    }
  }
}
</script>
<style lang="stylus">
.zoom-modal
  .el-dialog
    max-width 1100px
    .el-dialog__body
      width: 100%
      height 640px
      padding 10px 20px 20px 20px
      position relative
      .chart-wraper
        width 100%
        height 600px
        position relative
        .header
          display flex
          flex-direction row
          justify-content: space-between
          width 100%
          position absolute
          top -22px
          right 30px
          padding-left 30px
        .inner
          position absolute
          top: 16px
          width 100%
          height 100%
</style>
